import { render, staticRenderFns } from "./externalIdpComponent.vue?vue&type=template&id=4bad2f4e&scoped=true"
import script from "./externalIdpComponent.vue?vue&type=script&lang=js"
export * from "./externalIdpComponent.vue?vue&type=script&lang=js"
import style0 from "./externalIdpComponent.vue?vue&type=style&index=0&id=4bad2f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad2f4e",
  null
  
)

export default component.exports